<template>
  <DpplSkeletonLoader>
    <div
      :class="[
        'skeleton-filter-bar',
        $route.name === 'editor-view' ? 'is-editor' : '',
        fixed ? 'fixed' : '',
      ]"
    >
      <div class="skeleton-inner-filter-bar">
        <div class="skeleton-left-filters">
          <v-skeleton-loader
            type="text"
            width="42px"
            class="mr-6"
          />
          <v-skeleton-loader
            type="text"
            width="51px"
            class="mr-6"
          />
          <v-skeleton-loader
            type="text"
            width="105px"
            class="mr-14"
          />
          <v-skeleton-loader
            type="text"
            width="165px"
          />
        </div>
        <div class="skeleton-right-filters">
          <v-skeleton-loader
            type="text"
            width="73px"
            class="mr-7"
          />
          <v-skeleton-loader
            v-if="fixed"
            type="text"
            width="87px"
            class="mr-6"
          />
          <v-skeleton-loader
            type="text"
            width="55px"
            class="mr-6"
          />
          <v-skeleton-loader
            type="text"
            width="145px"
          />
        </div>
      </div>
    </div>
  </DpplSkeletonLoader>
</template>

<script>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';

export default {
  name: 'FilterBarSkeletonLoader',
  components: {
    DpplSkeletonLoader,
  },
  props: {
    animationIndex: { type: Number, default: 0 },
    fixed: { type: Boolean, default: true },
  },
};
</script>

<style lang="less" scoped>
.skeleton-filter-bar {
  left: 0;
  width: 100%;
  height: 56px;
  background: @white;
  border-bottom: 1px solid @stroke-default;
  z-index: 9;
  border-radius: 10px;
  padding: 0 16px;
  &.fixed {
    padding: 0 44px;
    border-radius: 0;
    .skeleton-inner-filter-bar {
      min-width: 1200px;
      max-width: 1400px;
    }
  }
}

.skeleton-inner-filter-bar {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  :deep(.v-skeleton-loader__text) {
    margin: 16px 0px;
  }
}

.is-editor {
  &.is-editor .skeleton-inner-filter-bar {
    min-width: 1200px;
    max-width: 1300px;
    width: 100%;
  }
  :deep(.skeleton path), :deep(.skeleton rect) {
    fill: @skeleton;
  }

  :deep(.skeleton .checkbox-skeleton-loader),
  :deep(.v-skeleton-loader .v-skeleton-loader__heading),
  :deep(.v-skeleton-loader .v-skeleton-loader__text) {
    background: @bg-canvas;
  }

  :deep(.v-skeleton-loader__text) {
    height: 20px;
    border-radius: 20px;
  }
}

.skeleton-left-filters {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.skeleton-right-filters {
  display: flex;
  align-items: center;
  padding-left: 44px;
  justify-content: flex-end;
}

</style>
